module.exports = __webpack_public_path__ + "img/cooperative0_logo35.935d4e3b.jpg";